import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

import { MyContext } from '../../../../Context/MyContext';
import pic from '../../../../Assets/home.jpg';
import socialmedia from '../../../../json/socialmedia';

const SocialIcon = ({ icon }) => {
  const icons = {
    fb: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
      </svg>
    ),
    ig: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
      </svg>
    ),
    tw: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
        <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53A4.48 4.48 0 0 0 22.43.36a9 9 0 0 1-2.88 1.1A4.52 4.52 0 0 0 16.11 0c-2.5 0-4.52 2-4.52 4.5 0 .35.04.7.11 1.03C7.69 5.36 4.07 3.6 1.64.96a4.49 4.49 0 0 0-.61 2.26c0 1.56.8 2.94 2 3.75A4.48 4.48 0 0 1 .96 6v.06c0 2.18 1.56 4 3.63 4.41a4.52 4.52 0 0 1-2.04.08 4.52 4.52 0 0 0 4.22 3.13A9.05 9.05 0 0 1 0 15.54 12.77 12.77 0 0 0 6.92 18c8.3 0 12.84-6.88 12.84-12.85 0-.2 0-.39-.02-.58A9.18 9.18 0 0 0 23 3z"/>
      </svg>
    ),
    yt: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
        <path d="M22.54 6.42A2.78 2.78 0 0 0 20.6 4.47C18.88 4 12 4 12 4s-6.88 0-8.6.47A2.78 2.78 0 0 0 1.46 6.42 29.11 29.11 0 0 0 1 12a29.11 29.11 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.4 19.53C5.12 20 12 20 12 20s6.88 0 8.6-.47a2.78 2.78 0 0 0 1.94-1.95A29.11 29.11 0 0 0 23 12a29.11 29.11 0 0 0-.46-5.58z"/>
        <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#fff"/>
      </svg>
    ),
  };
  return icons[icon] || null;
};

const Footer = () => {
  const { footerData } = useContext(MyContext);
  const { brand, columns, socials, copyright } = footerData;

  return (
    <footer className="footer">
      {/* Hero image strip */}
      <div className="footer-hero">
        <img src={pic} alt="footer background" className="footer-hero-img" />
        <div className="footer-hero-overlay">
          <h2 className="footer-hero-title">Find Your Dream Property</h2>
          <p className="footer-hero-sub">Explore thousands of verified listings across India.</p>
          <Link to="/properties" className="footer-hero-btn">Browse Properties</Link>
        </div>
      </div>

      {/* Main footer */}
      <div className="footer-main">
        <div className="footer-inner">
          {/* Brand col */}
          <div className="footer-brand-col">
            <div className="footer-logo">
              {/* <span className="footer-logo-icon">🌿</span> */}
              <span className="footer-logo-text">{brand.name}</span>
            </div>
            <p className="footer-tagline">{brand.tagline}</p>
            <p className="footer-desc">{brand.description}</p>

            <div className="footer-contact">
              <a href={`tel:${brand.contact_phone}`} className="footer-contact-item">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 2.11 4.18 2 2 0 0 1 4.09 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                {brand.contact_phone}
              </a>
              <a href={`mailto:${brand.contact_email}`} className="footer-contact-item">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                {brand.contact_email}
              </a>
            </div>

            {/* Socials */}
          <div className="footer-socials">
  {socialmedia
    .filter((s) => s.is_show)
    .map((s) => (
      <a
        key={s.id}
        href={s.url}
        target="_blank"
        rel="noopener noreferrer"
        className="footer-social-btn"
        title={s.label}
      >
        <i className={s.icon}></i>
      </a>
    ))}
</div>
          </div>

          {/* Link columns */}
          {columns.map(col => (
            <div key={col.id} className="footer-link-col">
              <h4 className="footer-col-heading">{col.heading}</h4>
              {col.links.map((l, i) => (
                <Link key={i} to={l.path} className="footer-link">{l.label}</Link>
              ))}
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <p>{copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;